let shopwareBaseUrl;
let creatorBaseUrl;
let shopwareShopId;
let shopLocale = 'de_DE';
let currency = 'EUR';
let auth = {};
let trackingConfig = {};
let backgroundRemovalCost = 5.0;
let defaultProduct = 'p508-m0-c2-s3';
let bgRemovalLandingPageUrl =
  'https://www.shirtinator.de/hintergrund-entfernen';
let translations;
let uploadFileSizeLimit = 25;
let defaultMotifs = [];
let maxGrossValue = Number.MAX_SAFE_INTEGER;
let maxGrossValueEnabled = false;
let maxGrossValueDisplayMessage = false;

if (typeof window !== 'undefined') {
  // Do browser config
  shopwareBaseUrl = window.CREATOR_CONFIG.SHOPWARE_BASE_URL.replace(/\/$/, '');
  creatorBaseUrl = window.CREATOR_CONFIG.CREATOR_BASE_URL.replace(/\/$/, '');
  shopwareShopId = window.CREATOR_CONFIG.SHOP_ID;
  shopLocale = window.CREATOR_CONFIG.LOCALE || shopLocale;
  auth = window.CREATOR_CONFIG.auth;
  // Exception: CustomerCare creator has no tracking config
  if (window.CREATOR_CONFIG.TRACKING_CONFIG) {
    trackingConfig = window.CREATOR_CONFIG.TRACKING_CONFIG;
  }
  backgroundRemovalCost = window.CREATOR_CONFIG.COSTS.backgroundRemoval;
  defaultProduct = window.CREATOR_CONFIG.DEFAULT_PRODUCT || defaultProduct;
  currency = window.CREATOR_CONFIG.CURRENCY || currency;
  bgRemovalLandingPageUrl =
    window.CREATOR_CONFIG.BACKGROUND_REMOVAL_LANDING_PAGE_URL ||
    bgRemovalLandingPageUrl;
  translations = window.CREATOR_CONFIG.TRANSLATIONS;
  uploadFileSizeLimit = window.CREATOR_CONFIG.UPLOAD_FILE_SIZE_LIMIT || uploadFileSizeLimit;
  defaultMotifs = window.CREATOR_CONFIG.DEFAULT_MOTIFS.trim().split(',') || defaultMotifs;
  maxGrossValue = window.CREATOR_CONFIG.MAX_GROSS_AMOUNT || maxGrossValue;
  maxGrossValueEnabled = window.CREATOR_CONFIG.MAX_GROSS_AMOUNT_ENABLED_BUTTON || maxGrossValueEnabled;
  maxGrossValueDisplayMessage = window.CREATOR_CONFIG.MAX_GROSS_AMOUNT_ENABLED_MESSAGE || maxGrossValueDisplayMessage;
} else if (typeof global !== 'undefined') {
  // Do node config
  require('dotenv').config();
  shopwareBaseUrl = global.process.env.SHOPWARE_BASE_URL.replace(/\/$/, '');
  creatorBaseUrl = global.process.env.CREATOR_BASE_URL.replace(/\/$/, '');
}

const apiBaseUrl = `${creatorBaseUrl}/api/v0/`;

export const API_BASE_URL = apiBaseUrl;
export const SHOPWARE_BASE_URL = shopwareBaseUrl;
export const SHOPWARE_SHOP_ID = shopwareShopId;
export const SHOPWARE_API_AUTH = auth;
export const TRACKING_CONFIG = trackingConfig;
export const CREATOR_BASE_URL = creatorBaseUrl;
export const BACKGROUND_REMOVAL_COST = backgroundRemovalCost;
export const DEFAULT_PRODUCT = defaultProduct;
export const SHOP_LOCALE = shopLocale.replace('_', '-');
export const CURRENCY = currency;
export const BACKGROUND_REMOVAL_LANDING_PAGE_URL = bgRemovalLandingPageUrl;
export const TRANSLATIONS = translations;
export const UPLOAD_FILE_SIZE_LIMIT = uploadFileSizeLimit;
export const DEFAULT_MOTIFS = defaultMotifs;
export const MAX_GROSS_VALUE = maxGrossValue;
export const MAX_GROSS_VALUE_ENABLED = maxGrossValueEnabled;
export const MAX_GROSS_VALUE_DISPLAY_MESSAGE = maxGrossValueDisplayMessage;
